// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%2710%27 viewBox=%270 0 20 20%27 fill=%27red%27><path d=%27M18.52 14.17l.01-.02L11.89 10l6.64-4.15-.01-.02A.97.97 0 0019 5c0-.55-.45-1-1-1-.2 0-.37.07-.52.17l-.01-.02L11 8.2V1c0-.55-.45-1-1-1S9 .45 9 1v7.2L2.53 4.15l-.01.02A.922.922 0 002 4c-.55 0-1 .45-1 1 0 .36.2.66.48.83l-.01.02L8.11 10l-6.64 4.15.01.02A.97.97 0 001 15c0 .55.45 1 1 1 .2 0 .37-.07.52-.17l.01.02L9 11.8V19c0 .55.45 1 1 1s1-.45 1-1v-7.2l6.47 4.04.01-.02c.15.11.32.18.52.18.55 0 1-.45 1-1 0-.36-.2-.66-.48-.83z%27 fill-rule=%27evenodd%27></path></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Generic setup for single-page full-screen web app. Make everything span the
 * full height and width of the browser window, hide the scrollbars, and
 * declare a default font name and size. */
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 */
html {
  height: 100%;
  overflow: hidden;
}
body {
  font-family: Arial, sans-serif;
  font-size: 14px;
  margin: 0;
  padding: 0;
  overflow: hidden;
  height: 100%;
}
/* react-root-container is the part that is governed by React. This also has
 * to fill the full window */
#react-root-container {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
}
.signin-field {
  text-align: left;
}
.account-info .bp5-dialog-footer {
  margin: 0px;
}
#app {
  display: flex;
  flex-flow: row nowrap;
  height: 100%;
  align-items: stretch;
  overflow: hidden;
}
#sidebar-container {
  max-width: 320px;
}
#workbench-container {
  flex: auto;
  height: 100%;
  overflow: hidden;
  padding-left: 1px;
  padding-right: 1px;
  padding-bottom: 1px;
}
.tree-container {
  overflow: auto;
  width: "100%";
}
.tree-container:focus {
  outline: none;
  /* prevent focus ring on containers of tree widgets */
}
.panel {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  /* align horizontal */
  align-items: center;
}
.panel-background-hint {
  color: #aaa;
  text-align: center;
}
.bp5-popover-content .bp5-menu {
  max-height: 320px;
  overflow-y: auto;
}
.bp5-popover-wrapper {
  width: 100%;
}
.bp5-popover-target {
  width: 100%;
}
.bp5-popover-wrapper {
  width: 100%;
}
.bp5-popover-target {
  width: 100%;
}
.bp5-button-text {
  width: 100%;
}
.tree-node-focused {
  box-shadow: 0 0px 4px 2px rgba(128, 180, 255, 0.6);
}
.bp5-tree-node-secondary-label {
  color: #5c7080;
}
.bp5-tree-node.bp5-tree-node-selected .bp5-tree-node-secondary-label {
  color: #ffffff;
}
.bp5-tree-node-secondary-label svg.pt-icon {
  margin-top: 5px;
}
.lm_dragProxy .lm_content {
  height: 100%;
}
.bp5-portal {
  z-index: 2000;
}
.bp5-select-popover {
  min-width: 400px;
}
.override-tooltip-target-style {
  display: initial;
}
h5 {
  font-weight: 600;
  margin: 0px;
  padding: 0px;
  line-height: 17px;
  font-size: 14px;
}
h3 {
  font-weight: 600;
  margin: 0 0 10px;
  padding: 0;
  line-height: 23px;
  font-size: 20px;
}
.checkbox-panel-style {
  margin-bottom: 0px !important;
  padding-left: 31px !important;
}
.bp5-table-quadrant-scroll-container {
  background: #ffffff;
}
.lm_goldenlayout {
  background: none;
}
body {
  background: #e5e8eb;
}
#version-info,
#contact,
.bp5-tag,
.bp5-table-row-name,
.bp5-table-column-name,
.bp5-table-cell,
.bp5-heading,
.bp5-non-ideal-state,
.bp5-button-text,
.bp5-radio {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.bp5-table-cell {
  font-variant-numeric: tabular-nums;
}
/*
.@{ns}-card {
  height: 100%;
  padding: 3px !important;
}*/
.editor-dialog-portal {
  z-index: 1900 !important;
}
.transport-editor-dialog-portal .bp5-dialog-body {
  margin: 0px;
}
.nodeproduct-detail-dialog-portal {
  z-index: 1800 !important;
}
.production-plan-dialog-portal {
  z-index: 1800 !important;
}
.wb-badge {
  background: rgba(0, 0, 0, 0) !important;
}
.wb-badge::after {
  z-index: 1;
  content: "";
  width: 10px;
  height: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  position: absolute;
  top: 0px;
  left: 0px;
  cursor: default;
}
.wb-perspective-bar .wb-perspective-bar-item {
  cursor: default;
}
.blueprintFormComponentMultilineTitle .bp5-icon > svg {
  fill: #738091;
}
.blueprintFormComponentTitle .bp5-icon > svg {
  fill: #738091;
}
.lm_controls .lm_maximise {
  display: none;
}
#ChangesetsDialog .bp5-dialog-footer {
  margin: 0px !important;
}
#PromptDialog .bp5-dialog-footer {
  margin: 0px !important;
}
#EditorDialog .bp5-dialog-footer {
  margin: 0px !important;
}
#TableEditorDialog .bp5-dialog-footer {
  margin: 0px !important;
}
#loadingPlanFormEditor .bp5-dialog-footer {
  margin: 0px !important;
}
#productionRecipeFormEditor .bp5-dialog-footer {
  margin: 0px !important;
}
#ProductionSettingsEditorDialog .bp5-dialog-footer {
  margin: 0px !important;
}
#TransportEditorPopup .bp5-dialog-footer {
  margin: 0px !important;
}
#productionTankEditor .bp5-dialog-footer {
  margin: 0px !important;
}
.ProductionTankBlockElementEditor .bp5-dialog-footer {
  margin: 0px !important;
}
.LoadingPlanTableEditor .bp5-dialog-footer {
  margin: 0px !important;
}
.bp5-dialog {
  background: #ffffff !important;
}
.bp5-dialog .bp5-dialog-header {
  background: #ffffff !important;
}
div.blueprintFormFieldWrapper .bp5-input-group.bp5-disabled > input {
  color: #111418;
}
div.blueprintFormFieldWrapper .bp5-input-group.bp5-disabled .bp5-button.bp5-disabled > span.bp5-button-text {
  color: #111418;
}
.fieldModifier60percentComponentWidth .form-field-label {
  width: calc(100% - 60%);
}
.fieldModifier60percentComponentWidth .form-field-component {
  width: 60%;
}
.fieldModifier65percentComponentWidth .form-field-label {
  width: calc(100% - 65%);
}
.fieldModifier65percentComponentWidth .form-field-component {
  width: 65%;
}
.fieldModifier75percentComponentWidth .form-field-label {
  width: calc(100% - 75%);
}
.fieldModifier75percentComponentWidth .form-field-component {
  width: 75%;
}
.fieldModifier25percentComponentWidth .form-field-label {
  width: calc(100% - 25%);
}
.fieldModifier25percentComponentWidth .form-field-component {
  width: 25%;
}
.fieldModifier20percentComponentWidth .form-field-label {
  width: calc(100% - 20%);
}
.fieldModifier20percentComponentWidth .form-field-component {
  width: 20%;
}
.fieldModifierMaxComponentWidth .form-field-label {
  width: auto;
  flex: unset;
}
.fieldModifierMaxComponentWidth .form-field-component {
  flex: 1 1 0px;
}
.fieldModifierHideLabel .form-field-label {
  display: none;
}
.fieldModifierHideLabel .form-field-component {
  flex: 1 1 0px;
}
.fieldModifierDisabledRequireMarker .field-required-marker-wrapper {
  display: none;
}
.bp5-numeric-input .bp5-input {
  text-align: end;
}
.bp5-button.bp5-disabled.bp5-minimal.numeric-input-unit .bp5-button-text {
  color: #111418;
}
.disabled-editor-dialog-form-footer .bp5-dialog-body .form-footer {
  display: none;
}
.disabled-dialog-footer .bp5-dialog .bp5-dialog-footer {
  display: none;
}
.collapsible-form-section {
  gap: 5px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #d3d8de;
  cursor: pointer;
  min-height: 30px;
  margin-left: -5px;
  margin-right: -5px;
  padding-left: 10px;
  padding-right: 10px;
}
.collapsible-form-section .bp5-icon {
  cursor: pointer;
}
.collapsible-form-section .bp5-icon.field-info-icon {
  padding-bottom: 1.5px;
  padding-left: 3px;
}
.collapsible-form-section:hover {
  background-color: rgba(211, 216, 222, 0.2);
}
.bp5-input-group.bp5-disabled .bp5-input:disabled {
  color: #111418;
}
.loading-plan-time {
  position: relative;
}
.loading-plan-time::after {
  content: attr(aria-details);
  position: absolute;
  top: 33px;
  left: 0px;
  padding-left: 10px;
  font-size: 12px;
  color: #111418;
}
.bp5-button.bp5-fill.bp5-align-left.button-select .bp5-button-text {
  overflow: hidden;
}
.column-header-infotext-icon {
  color: #738091 !important;
}
.bp5-table-header-content .bp5-input-group.bp5-disabled .bp5-input:disabled {
  color: #738091;
}
.time-series-chart-wrapper > div:first-child {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/app.less"],"names":[],"mappings":"AAAA;;0CAE0C;AAC1C;;EAEE;AACF;EACI,YAAA;EACA,gBAAA;AACJ;AAEA;EACI,8BAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EAEA,YAAA;AADJ;AACA;4BAC4B;AAI5B;EACI,sBAAA;EACA,YAAA;EACA,WAAA;AAFJ;AAKA;EACI,gBAAA;AAHJ;AAMC;EACG,WAAA;AAJJ;AAOA;EACI,aAAA;EACA,qBAAA;EACA,YAAA;EAEA,oBAAA;EAEA,gBAAA;AAPJ;AAUA;EACI,gBAAA;AARJ;AAWA;EACI,UAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AATJ;AAYA;EAKI,cAAA;EACA,aAAA;AAdJ;AASI;EACI,aAAA;EAPN,qDAAqD;AACvD;AAaA;EACI,YAAA;EACA,WAAA;EAEA,aAAA;EACA,iBAAA;EACA,uBAAA;EAZF,qBAAqB;EAanB,mBAAA;AAXJ;AAcA;EACI,WAAA;EACA,kBAAA;AAZJ;AAeC;EACG,iBAAA;EACA,gBAAA;AAbJ;AAgBC;EACG,WAAA;AAdJ;AAiBC;EACG,WAAA;AAfJ;AAkBC;EACG,WAAA;AAhBJ;AAmBC;EACG,WAAA;AAjBJ;AAoBC;EACG,WAAA;AAlBJ;AAqBA;EAEI,kDAAA;AApBJ;AAuBC;EACG,cAAA;AArBJ;AAuBK;EACG,cAAA;AArBR;AAiBC;EAQO,eAAA;AAtBR;AA0BA;EACI,YAAA;AAxBJ;AA2BC;EACG,aAAA;AAzBJ;AA4BC;EACG,gBAAA;AA1BJ;AA6BA;EACI,gBAAA;AA3BJ;AA8BA;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AA5BJ;AA+BA;EACI,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;AA7BJ;AAgCA;EACI,6BAAA;EACA,6BAAA;AA9BJ;AAiCC;EACG,mBAAA;AA/BJ;AAkCA;EACI,gBAAA;AAhCJ;AAmCA;EACI,mBAAA;AAjCJ;AAqCC;;;;;;;;;;EAUG,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;AAnCJ;AAsCC;EACG,kCAAA;AApCJ;AACA;;;;EAIE;AAwCF;EACI,wBAAA;AAtCJ;AA+CC;EACG,WAAA;AA7CJ;AAoDA;EACI,wBAAA;AAlDJ;AAqDA;EACI,wBAAA;AAnDJ;AAsDA;EACI,uCAAA;AApDJ;AAuDA;EACI,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mDAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;AArDJ;AAwDA;EACI,eAAA;AAtDJ;AAyDC;EACG,aAAA;AAvDJ;AA0DC;EACG,aAAA;AAxDJ;AA4DA;EACI,aAAA;AA1DJ;AA6DC;EACG,sBAAA;AA3DJ;AA8DC;EACG,sBAAA;AA5DJ;AA+DC;EACG,sBAAA;AA7DJ;AAgEC;EACG,sBAAA;AA9DJ;AAiEC;EACG,sBAAA;AA/DJ;AAkEC;EACG,sBAAA;AAhEJ;AAmEC;EACG,sBAAA;AAjEJ;AAoEC;EACG,sBAAA;AAlEJ;AAqEC;EACG,sBAAA;AAnEJ;AAsEC;EACG,sBAAA;AApEJ;AAuEC;EACG,sBAAA;AArEJ;AAwEC;EACG,8BAAA;AAtEJ;AAwEK;EACG,8BAAA;AAtER;AA4EQ;EACI,cAAA;AA1EZ;AA6ES;EACG,cAAA;AA3EZ;AAiFI;EACI,uBAAA;AA/ER;AAiFI;EACI,UAAA;AA/ER;AAoFI;EACI,uBAAA;AAlFR;AAoFI;EACI,UAAA;AAlFR;AAuFI;EACI,uBAAA;AArFR;AAuFI;EACI,UAAA;AArFR;AA0FI;EACI,uBAAA;AAxFR;AA0FI;EACI,UAAA;AAxFR;AA6FI;EACI,uBAAA;AA3FR;AA6FI;EACI,UAAA;AA3FR;AAgGI;EACI,WAAA;EACA,WAAA;AA9FR;AAgGI;EACI,aAAA;AA9FR;AAmGI;EACI,aAAA;AAjGR;AAmGI;EACI,aAAA;AAjGR;AAsGI;EACI,aAAA;AApGR;AAwGC;EACG,eAAA;AAtGJ;AA8GC;EACG,cAAA;AA5GJ;AAgHC;EACG,aAAA;AA9GJ;AAmHC;EACG,aAAA;AAjHJ;AAoHA;EACI,QAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAlHJ;AAoHK;EACG,eAAA;AAlHR;AAqHK;EACG,qBAAA;EACA,iBAAA;AAnHR;AAuHA;EACI,0CAAA;AArHJ;AAwHC;EACG,cAAA;AAtHJ;AAyHA;EACI,kBAAA;AAvHJ;AAyHI;EACI,2BAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAvHR;AA6HC;EACG,gBAAA;AA3HJ;AA+HA;EACI,yBAAA;AA7HJ;AAgIC;EACG,cAAA;AA9HJ;AAiIA;EACI,WAAA;AA/HJ","sourcesContent":["/* Generic setup for single-page full-screen web app. Make everything span the\n * full height and width of the browser window, hide the scrollbars, and\n * declare a default font name and size. */\n\n@import \"~@blueprintjs/core/lib/less/variables\";\n\nhtml {\n    height: 100%;\n    overflow: hidden;\n}\n\nbody {\n    font-family: Arial, sans-serif;\n    font-size: 14px;\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n\n    height: 100%;\n}\n\n/* react-root-container is the part that is governed by React. This also has\n * to fill the full window */\n#react-root-container {\n    box-sizing: border-box;\n    height: 100%;\n    width: 100%;\n}\n\n.signin-field {\n    text-align: left;\n}\n\n.account-info .@{ns}-dialog-footer {\n    margin: 0px;\n}\n\n#app {\n    display: flex;\n    flex-flow: row nowrap;\n    height: 100%;\n\n    align-items: stretch;\n\n    overflow: hidden;\n}\n\n#sidebar-container {\n    max-width: 320px;\n}\n\n#workbench-container {\n    flex: auto;\n    height: 100%;\n    overflow: hidden;\n    padding-left: 1px;\n    padding-right: 1px;\n    padding-bottom: 1px;\n}\n\n.tree-container {\n    &:focus {\n        outline: none; /* prevent focus ring on containers of tree widgets */\n    }\n\n    overflow: auto;\n    width: \"100%\";\n}\n\n.panel {\n    height: 100%;\n    width: 100%;\n\n    display: flex;\n    flex-flow: column;\n    justify-content: center; /* align horizontal */\n    align-items: center;\n}\n\n.panel-background-hint {\n    color: #aaa;\n    text-align: center;\n}\n\n.@{ns}-popover-content .@{ns}-menu {\n    max-height: 320px;\n    overflow-y: auto;\n}\n\n.@{ns}-popover-wrapper {\n    width: 100%;\n}\n\n.@{ns}-popover-target {\n    width: 100%;\n}\n\n.@{ns}-popover-wrapper {\n    width: 100%;\n}\n\n.@{ns}-popover-target {\n    width: 100%;\n}\n\n.@{ns}-button-text {\n    width: 100%;\n}\n\n.tree-node-focused {\n    // box-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);\n    box-shadow: 0 0px 4px 2px rgba(128, 180, 255, 0.6);\n}\n\n.@{ns}-tree-node-secondary-label {\n    color: #5c7080;\n\n    .@{ns}-tree-node.@{ns}-tree-node-selected & {\n        color: #ffffff;\n    }\n\n    svg.pt-icon {\n        margin-top: 5px; // assumes 16px icon and 30px tree node\n    }\n}\n\n.lm_dragProxy .lm_content {\n    height: 100%;\n}\n\n.@{ns}-portal {\n    z-index: 2000;\n}\n\n.@{ns}-select-popover {\n    min-width: 400px;\n}\n\n.override-tooltip-target-style {\n    display: initial;\n}\n\nh5 {\n    font-weight: 600;\n    margin: 0px;\n    padding: 0px;\n    line-height: 17px;\n    font-size: 14px;\n}\n\nh3 {\n    font-weight: 600;\n    margin: 0 0 10px;\n    padding: 0;\n    line-height: 23px;\n    font-size: 20px;\n}\n\n.checkbox-panel-style {\n    margin-bottom: 0px !important;\n    padding-left: 31px !important;\n}\n\n.@{ns}-table-quadrant-scroll-container {\n    background: @white;\n}\n\n.lm_goldenlayout {\n    background: none;\n}\n\nbody {\n    background: @light-gray3;\n    // background: url(../image/background.png) repeat;\n}\n\n#version-info,\n#contact,\n.@{ns}-tag,\n.@{ns}-table-row-name,\n.@{ns}-table-column-name,\n.@{ns}-table-cell,\n.@{ns}-heading,\n.@{ns}-non-ideal-state,\n.@{ns}-button-text,\n.@{ns}-radio {\n    user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n}\n\n.@{ns}-table-cell {\n    font-variant-numeric: tabular-nums;\n}\n\n/*\n.@{ns}-card {\n  height: 100%;\n  padding: 3px !important;\n}*/\n\n.editor-dialog-portal {\n    z-index: 1900 !important;\n}\n\n// .transport-editor-dialog-portal {\n//     z-index: 1800 !important;\n// }\n\n// Transport editor body has a part with \"extra\" dialog body CSS class.\n// We want to remove the margin from the original dialog body.\n.transport-editor-dialog-portal .@{ns}-dialog-body {\n    margin: 0px;\n}\n\n// .transport-editor-dialog-portal-no-z-index.transport-editor-dialog-portal {\n//     z-index: 2000 !important; // Default for the blueprint dialogs\n// }\n\n.nodeproduct-detail-dialog-portal {\n    z-index: 1800 !important;\n}\n\n.production-plan-dialog-portal {\n    z-index: 1800 !important;\n}\n\n.wb-badge {\n    background: rgba(0, 0, 0, 0) !important;\n}\n\n.wb-badge::after {\n    z-index: 1;\n    content: \"\";\n    width: 10px;\n    height: 10px;\n    background: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 20 20' fill='red'><path d='M18.52 14.17l.01-.02L11.89 10l6.64-4.15-.01-.02A.97.97 0 0019 5c0-.55-.45-1-1-1-.2 0-.37.07-.52.17l-.01-.02L11 8.2V1c0-.55-.45-1-1-1S9 .45 9 1v7.2L2.53 4.15l-.01.02A.922.922 0 002 4c-.55 0-1 .45-1 1 0 .36.2.66.48.83l-.01.02L8.11 10l-6.64 4.15.01.02A.97.97 0 001 15c0 .55.45 1 1 1 .2 0 .37-.07.52-.17l.01.02L9 11.8V19c0 .55.45 1 1 1s1-.45 1-1v-7.2l6.47 4.04.01-.02c.15.11.32.18.52.18.55 0 1-.45 1-1 0-.36-.2-.66-.48-.83z' fill-rule='evenodd'></path></svg>\");\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    cursor: default;\n}\n\n.wb-perspective-bar .wb-perspective-bar-item {\n    cursor: default;\n}\n\n.blueprintFormComponentMultilineTitle .@{ns}-icon > svg {\n    fill: @gray2;\n}\n\n.blueprintFormComponentTitle .@{ns}-icon > svg {\n    fill: @gray2;\n}\n\n// Workaround: we can not set custom config for the workbench when we select a perspective\n.lm_controls .lm_maximise {\n    display: none;\n}\n\n#ChangesetsDialog .@{ns}-dialog-footer {\n    margin: 0px !important;\n}\n\n#PromptDialog .@{ns}-dialog-footer {\n    margin: 0px !important;\n}\n\n#EditorDialog .@{ns}-dialog-footer {\n    margin: 0px !important;\n}\n\n#TableEditorDialog .@{ns}-dialog-footer {\n    margin: 0px !important;\n}\n\n#loadingPlanFormEditor .@{ns}-dialog-footer {\n    margin: 0px !important;\n}\n\n#productionRecipeFormEditor .@{ns}-dialog-footer {\n    margin: 0px !important;\n}\n\n#ProductionSettingsEditorDialog .@{ns}-dialog-footer {\n    margin: 0px !important;\n}\n\n#TransportEditorPopup .@{ns}-dialog-footer {\n    margin: 0px !important;\n}\n\n#productionTankEditor .@{ns}-dialog-footer {\n    margin: 0px !important;\n}\n\n.ProductionTankBlockElementEditor .@{ns}-dialog-footer {\n    margin: 0px !important;\n}\n\n.LoadingPlanTableEditor .@{ns}-dialog-footer {\n    margin: 0px !important;\n}\n\n.@{ns}-dialog {\n    background: @white !important;\n\n    & .@{ns}-dialog-header {\n        background: @white !important;\n    }\n}\n\ndiv.blueprintFormFieldWrapper {\n    & .@{ns}-input-group.@{ns}-disabled {\n        & > input {\n            color: @black;\n        }\n\n        & .@{ns}-button.@{ns}-disabled > span.@{ns}-button-text {\n            color: @black;\n        }\n    }\n}\n\n.fieldModifier60percentComponentWidth {\n    & .form-field-label {\n        width: calc(100% - 60%);\n    }\n    & .form-field-component {\n        width: 60%;\n    }\n}\n\n.fieldModifier65percentComponentWidth {\n    & .form-field-label {\n        width: calc(100% - 65%);\n    }\n    & .form-field-component {\n        width: 65%;\n    }\n}\n\n.fieldModifier75percentComponentWidth {\n    & .form-field-label {\n        width: calc(100% - 75%);\n    }\n    & .form-field-component {\n        width: 75%;\n    }\n}\n\n.fieldModifier25percentComponentWidth {\n    & .form-field-label {\n        width: calc(100% - 25%);\n    }\n    & .form-field-component {\n        width: 25%;\n    }\n}\n\n.fieldModifier20percentComponentWidth {\n    & .form-field-label {\n        width: calc(100% - 20%);\n    }\n    & .form-field-component {\n        width: 20%;\n    }\n}\n\n.fieldModifierMaxComponentWidth {\n    & .form-field-label {\n        width: auto;\n        flex: unset;\n    }\n    & .form-field-component {\n        flex: 1 1 0px;\n    }\n}\n\n.fieldModifierHideLabel {\n    & .form-field-label {\n        display: none;\n    }\n    & .form-field-component {\n        flex: 1 1 0px;\n    }\n}\n\n.fieldModifierDisabledRequireMarker {\n    & .field-required-marker-wrapper {\n        display: none;\n    }\n}\n\n.@{ns}-numeric-input .bp5-input {\n    text-align: end;\n}\n\n// .bp5-dialog .bp5-dialog-footer {\n//     display: none;\n// }\n\n\n.@{ns}-button.@{ns}-disabled.@{ns}-minimal.numeric-input-unit .bp5-button-text {\n    color: @black;\n}\n\n// This will hide the footer buttons when we use with `portalClassName`\n.disabled-editor-dialog-form-footer .@{ns}-dialog-body .form-footer {\n    display: none;\n}\n\n// This will hide the footer buttons when we have a non-editor dialog\n// (Editor and non-editor dialogs have different structure and they need different CSS rules)\n.disabled-dialog-footer .@{ns}-dialog .@{ns}-dialog-footer {\n    display: none;\n}\n\n.collapsible-form-section {\n    gap: 5px;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid @light-gray1;\n    cursor: pointer;\n    min-height: 30px;\n    margin-left: -5px;\n    margin-right: -5px;\n    padding-left: 10px;\n    padding-right: 10px;\n\n    & .@{ns}-icon {\n        cursor: pointer;\n    }\n\n    & .@{ns}-icon.field-info-icon {\n        padding-bottom: 1.5px;\n        padding-left: 3px;\n    }\n}\n\n.collapsible-form-section:hover {\n    background-color: fade(@light-gray1, 20%);\n}\n\n.@{ns}-input-group.@{ns}-disabled .@{ns}-input:disabled {\n    color: @black;\n}\n\n.loading-plan-time {\n    position: relative;\n\n    &::after {\n        content: attr(aria-details);\n        position: absolute;\n        top: 33px;\n        left: 0px;\n        padding-left: 10px;\n        font-size: 12px;\n        color: @black;\n    }\n}\n\n// TODO: should this be placed into the `@mil/blueprint-components` library?\n// Fix for the selects to properly do the overflow ellipsis\n.@{ns}-button.@{ns}-fill.@{ns}-align-left.button-select .@{ns}-button-text {\n    overflow: hidden;\n}\n\n// TODO: this should be fixed in the @mil/blueprint-table-components library\n.column-header-infotext-icon {\n    color: @gray2 !important;\n}\n\n.@{ns}-table-header-content .@{ns}-input-group.@{ns}-disabled .@{ns}-input:disabled {\n    color: @gray2;\n}\n\n.time-series-chart-wrapper > div:first-child {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
